<script setup lang="ts">
const selected = defineModel<boolean>({ required: true });
</script>

<template>
  <button
    type="button"
    :aria-pressed="selected"
    :class="[
      'flex h-[36px] items-center rounded-full border px-md text-body font-semibold',
      selected
        ? 'border-transparent bg-tint text-white transition duration-300 outline-inner hover:bg-tint-hover active:bg-tint-hover'
        : 'border-quaternary bg-white text-primary state-effects',
    ]"
    @click="selected = !selected"
  >
    <slot />
  </button>
</template>
